<div class="loadingBoxOrange">
    <section *ngIf="doubleOpt" class="login-main-wrapper full-height">
        <div class="container-fluid pl-0 pr-0">
            <div class="row no-gutters row justify-content-center ">
                <div class="col-md-5 p-5 bg-dark-style authbox">
                   <div class="login-main-left">
                      <div class="text-center mb-5 login-main-left-header">
                         <img src="assets/img/hostbrand/core-whitelogo.svg" width="200" class="img-fluid" alt="LOGO">
                         
                           </div>
                         
                      <div class="text-center">
                        <div class="channels-card-body">
                            <div *ngIf="!disclaimerLoaded" class="channels-title sitesub">
                              <h2 class="pulsate">Loading...</h2>
                            </div>
                            <div *ngIf="disclaimerLoaded" class="channels-title sitesub">
                                <h2>
                                    <span i18n="@@Subscribe to | Subscribe to Label">Subscribe to</span> {{siteInfo.name}} </h2>
                                <span [innerHTML]="disclaimerHTML"></span>  <br/>
                            
                                 <!--<h3 i18n="@@What will I be charged? | What will I be charged Label">What will I be charged?</h3>
                                <p>
                                    <span i18n="@@You will be charged: | You will be charged Label">You will be charged:</span> {{currencySign}}{{siteInfo.cost}} {{siteRenew}}</p> -->
                                <a href="javascript:;" (click)="checkParams()" i18n="@@Subscribe Now | Subscribe Now Label" class="unsubbutton white-outline-button subButton">Subscribe Now</a>
                                <br/>
                                <a (click)="goToTermConditions()" i18n="@@Terms and Conditions | Terms and Conditions Link" class="unsubbutton white-outline-button">Terms and Conditions</a>

                            </div>
                        </div>
                         </div>
                   </div>
                </div>
          </div>
        </div>
     </section>
    <section *ngIf="userStatus" class="login-main-wrapper full-height">
        <div class="container-fluid pl-0 pr-0">
            <div class="row no-gutters row justify-content-center ">
                <div class="col-md-5 p-5 bg-dark-style authbox">
                   <div class="login-main-left">
                      <div class="text-center mb-5 login-main-left-header">
                         <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                         
                           </div>
                         
                      <div class="text-center">
                        <br/><br/>
                       <h3 i18n="@@Confirming Subscription | Confirming Subscription Link" class="pulsate">Confirming Subscription...</h3>
                         </div>
                   </div>
                </div>
          </div>
        </div>
     </section>
     <section *ngIf="failedSub" class="login-main-wrapper full-height">
        <div class="container-fluid pl-0 pr-0">
            <div class="row no-gutters row justify-content-center ">
                <div class="col-md-5 p-5 bg-dark-style authbox">
                   <div class="login-main-left">
                      <div class="text-center mb-5 login-main-left-header">
                         <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                         
                           </div>
                         
                      <div class="text-center">
                        <br/><br/>
                       <h3 i18n="@@Your subscription attempt failed check phone | Your subscription attempt failed check phone Message">Your subscription attempt failed, this could be because you’re already subscribed or have insufficient funds. Please login or load more airtime to continue</h3>
                         </div>
                   </div>
                </div>
          </div>
        </div>
     </section>
     <section *ngIf="!userStatus" class="login-main-wrapper">
        <div *ngIf="showPass" class="container-fluid pl-0 pr-0">
            <div class="row no-gutters row justify-content-center ">
                <div class="col-md-5 p-5 bg-dark-style authbox">
                   <div class="login-main-left">
                      <div class="text-center mb-5 login-main-left-header">
                         <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                         
                           </div>
                           <p i18n="@@Profile Already Exists | Profile Already Exists Message">We see that you already have a profile with us. Please enter your password below to continue.</p>
                           <form name="sample-form" #f="ngForm">
                                      <div class="form-group">
                                              <label i18n="@@Password | Password Label">Password</label>
                                              <input minlength=6 type="password" (change)="onPasswordUp($event)" #password class="form-control" placeholder="">
                                      </div>
                                        <button (click)="loginUser()" type="button" class="form-control">
                                          <span i18n="@@Login | Login Button">Login</span>
                                        </button>
                                      </form>
                      <div class="text-center">
                        <br/>
                         </div>
                   </div>
                </div>
          </div>
        </div>
  
     </section> 
  </div>
